import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RoundupLandingPage from './round';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RoundupLandingPage />
  </React.StrictMode>
);
